export default function Invite() {
  return (
    <div>
      <h2>ПРИГЛАСИТЬ НА СЪËМКУ</h2>
      <p>Свяжитесь со мной в <a href="https://instagram.com/ziwendys" rel="noreferrer" target="_blank">Instagram</a> или <a href="https://t.me/ziwendys" rel="noreferrer" target="_blank">Telegram</a>, и мы обо всём договоримся!</p>
    </div>
  )
}
